module.exports = __webpack_public_path__ + "static/media/hdmiIn.abf9a759.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/hdmiIn.svg
// module id = 1416
// module chunks = 1